import { useEffect } from 'react';
import { SEOConfig } from '../utils/seoConfig';

export const useSEO = (config: SEOConfig) => {
  useEffect(() => {
    const baseUrl = 'https://3arrowsmedia.com';
    const ogImage = config.ogImage || `${baseUrl}/og-image.png`;

    document.title = config.title;

    const updateMetaTag = (name: string, content: string, isProperty = false) => {
      const attribute = isProperty ? 'property' : 'name';
      let element = document.querySelector(
        `meta[${attribute}="${name}"]`
      ) as HTMLMetaElement | null;

      if (!element) {
        element = document.createElement('meta');
        element.setAttribute(attribute, name);
        document.head.appendChild(element);
      }

      element.setAttribute('content', content);
    };

    updateMetaTag('description', config.description);
    updateMetaTag('keywords', config.keywords.join(', '));
    
    const ogTitle = config.ogTitle || config.title;
    const ogDescription = config.ogDescription || config.description;
    const ogType = config.ogType || 'website';
    const ogUrl = config.ogUrl || baseUrl;

    updateMetaTag('og:title', ogTitle, true);
    updateMetaTag('og:description', ogDescription, true);
    updateMetaTag('og:url', ogUrl, true);
    updateMetaTag('og:image', ogImage, true);
    updateMetaTag('og:type', ogType, true);
    updateMetaTag('twitter:title', ogTitle, true);
    updateMetaTag('twitter:description', ogDescription, true);
    updateMetaTag('twitter:image', ogImage, true);

    const canonicalLink = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    const canonical = config.canonical || ogUrl;
    if (canonicalLink) {
      canonicalLink.href = canonical;
    } else {
      const newCanonical = document.createElement('link');
      newCanonical.rel = 'canonical';
      newCanonical.href = canonical;
      document.head.appendChild(newCanonical);
    }

    window.scrollTo(0, 0);
  }, [config]);
};
